<div class="top-dialog-content p-4">
  <!-- Close Button Row -->
  <div class="d-flex justify-content-end mb-2">
    <span class="close-button cursor-pointer" (click)="onCancel()">
      <span>{{ 'admin.store.close' | translate }}</span>
      <app-icon icon="fas fa-times"></app-icon>
    </span>
  </div>

  <!-- Title -->
  <h1 class="mb-3">{{ data.title }}</h1>

  <!-- Search Bar (Full Width) -->
  <div class="form-group mb-4">
    <app-input-text
      [bare]="true"
      [value]="searchText"
      (inputEvent)="searchText = $any($event.target).value; onSearch()"
      [placeholder]="
        data.searchPlaceholder || ('admin.global.search' | translate)
      "
    ></app-input-text>
  </div>

  <!-- Loading State -->
  <app-loading-panel
    [showLoading]="loading"
    [variant]="'default'"
    [hideText]="false"
  ></app-loading-panel>

  <!-- Table -->
  <div
    class="table-responsive mb-3"
    *ngIf="!loading && paginatedItems.length > 0"
  >
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th style="width: 50px"></th>
          <th>{{ 'admin.store.catalog.modal.name' | translate }}</th>
          <th>{{ 'admin.store.catalog.modal.description' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of paginatedItems"
          (click)="toggleSelection(item.id)"
          [class.table-active]="isSelected(item.id)"
          class="cursor-pointer"
        >
          <td class="position-relative">
            <div *ngIf="isItemLoading(item.id)" class="loading-overlay">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
              ></span>
            </div>
            <!-- Opacity must sit on a real box: app-checkbox's host is
                 display:contents and generates none, silently dropping it. -->
            <span
              class="d-inline-block"
              [style.opacity]="isItemLoading(item.id) ? '0.3' : '1'"
            >
              <app-checkbox
                labelClass="mb-0"
                [checked]="isSelected(item.id)"
                [disabled]="isItemLoading(item.id)"
                [stopClickPropagation]="true"
                (changeEvent)="toggleSelection(item.id)"
              ></app-checkbox>
            </span>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.description || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Empty State -->
  <div class="text-center py-5" *ngIf="!loading && paginatedItems.length === 0">
    <p class="text-muted">
      {{
        data.emptyMessage || ('admin.store.catalog.noItemsFound' | translate)
      }}
    </p>
  </div>

  <!-- Pagination -->
  <div
    class="d-flex justify-content-between align-items-center"
    *ngIf="!loading && paginatedItems.length > 0"
  >
    <div class="text-muted">
      {{ 'admin.store.catalog.modal.showing' | translate }}
      {{ getStartIndex() + 1 }}
      {{ 'admin.store.catalog.modal.to' | translate }} {{ getEndIndex() }}
      {{ 'admin.store.catalog.modal.of' | translate }} {{ totalElements }}
      {{ 'admin.store.catalog.modal.items' | translate }}
      <span *ngIf="getSelectedCount() > 0" class="ml-2">
        ({{ getSelectedCount() }}
        {{ 'admin.store.catalog.modal.selected' | translate }})
      </span>
    </div>
    <app-pager
      [page]="currentPage"
      [size]="pageSize"
      [totalPagesCount]="totalPages"
      (paginate)="onPageChange($event)"
    ></app-pager>
  </div>
</div>
